









































































































































































import { TutorSession } from "@/views/Tutorials.vue";
import { defineComponent, ref } from "@vue/composition-api";
import { useUserServiceInject } from "@/context";

export default defineComponent({
  name: "TutorSessionView",
  data() {
    return {
      isFormValid: true,
      participantRules: [
        (v: any) => v < 100 || "Ihre Eingabe muss kleiner 100 sein.",
        (v: any) => v >= 0 || "Ihre Eingabe muss größer gleich 0 sein.",
        (v: any) =>
          /^(0|[1-9][0-9]{0,1})$/.test(v) ||
          "Es sind nur Ziffern und keine führenden Nullen erlaubt.",
      ],
      newParticipants: 0,
    };
  },
  methods: {
    getTableData() {
      return [
        { key: "Tutor", value: this.getTutorName(), icon: "mdi-account" },
        {
          key: "Datum",
          value: this.getExactDateInGermany(
            this.getExactDate(this.tutorSession.group, this.tutorSession.day)
          ),
          icon: "mdi-calendar",
        },
        {
          key: "Uhrzeit",
          value: this.tutorSession.start + " - " + this.tutorSession.end,
          icon: "mdi-clock",
        },
        {
          key: "Belegung",
          value: this.formatCap(this.tutorialInfo.capacity),
          icon: "mdi-arrow-collapse-horizontal",
        },
        {
          key: "Format",
          value: this.formatFormat2(this.tutorialInfo.format),
          icon: "mdi-close-thick",
        },
        {
          key: "Raum",
          value: this.tutorialInfo.room,
          icon: "mdi-map-marker",
          noShow: this.tutorialInfo.format != "PRESENCE",
        },
        {
          key: "Link",
          value: this.tutorSession.link,
          icon: "mdi-link",
          action: {
            method: this.updateLink,
            text: "Bitte geben Sie den Link dieser Tutorstunde an:",
            type: "text",
          },
          noShow: this.tutorialInfo.format != "ONLINE",
        },
        {
          key: "Raumzugangscode",
          value: this.tutorSession.password,
          icon: "mdi-lock",
          action: {
            method: this.updateLinkPassword,
            text: "Bitte geben Sie das Raumzugangscode dieser Tutorstunde an:",
            type: "text",
          },
          noShow: this.tutorialInfo.format != "ONLINE",
        },
        {
          key: "Teilnehmer",
          value: this.tutorSession.participants,
          icon: "mdi-account-group",
          action: {
            method: this.updateParticipants,
            text: "Bitte geben Sie die Anzahl der Teilnehmer dieser Tutorstunde an:",
            type: "number",
          },
        },
      ];
    },
    getTutorName() {
      if (!this.tutorInfo) return "";
      if (this.tutorInfo["firstName"]) {
        return this.tutorInfo["firstName"] + " " + this.tutorInfo["lastName"];
      }
      return this.tutorInfo["username"];
    },

    formatCap(c: string) {
      if (!c) return "";
      if (c === "NOT_CROWDED") {
        return "kaum";
      } else if (c === "NORMAL") {
        return "normal";
      } else if (c === "CROWDED") {
        return "stärker";
      } else if (c === "BUSY") {
        return "voll";
      } else {
        return "nicht angegeben";
      }
    },
    toProfile() {
      if (!this.tutorInfo) return;
      this.$router.push({
        name: "tutorials.profile.username",
        params: { username: this.tutorInfo.username },
      });
    },
    updateParticipants() {
      if (
        this.newParticipants &&
        this.newParticipants >= 0 &&
        this.newParticipants <= 99
      ) {
        this.$axios
          .patch("tutor_sessions/" + this.tutorSession.id + "/", {
            participants: this.newParticipants,
          })
          .then(() => {
            this.tutorSession.participants = this.newParticipants;
          })
          .catch(() => {
            this.newParticipants = this.tutorSession.participants as number;
            alert(this.$t("tutorSession.saveFailed"));
          });
      } else {
        alert(this.$t("tutorSession.correctNumber"));
      }
    },
  },
  setup(props, { root }) {
    const tutorSession = ref<TutorSession>({
      id: 0,
      group: "",
      name: "",
      start: "",
      end: "",
      day: "",
      status: "",
      tutor: 0,
      participants: 0,
      link: "",
      password: "",
    });
    const tutorInfo = ref<any>({});
    const tutorialInfo = ref<any>({});
    const { loggedIn, isTutor, isStaff, username } = useUserServiceInject();
    const editAllowed = isStaff;

    root.$axios
      .get("tutor_sessions/" + root.$route.params.sessionId)
      .then((req) => {
        const sessionData = req.data;
        const newSession: TutorSession = {
          id: sessionData["id"],
          group: sessionData["group"],
          name: sessionData["name"],
          start: sessionData["start"],
          end: sessionData["end"],
          day: sessionData["day"],
          status: sessionData["status"],
          tutor: sessionData["tutor"],
          participants: sessionData["participants"]
            ? sessionData["participants"]
            : 0,
          link: sessionData["link"],
          password: sessionData["link_password"],
        };

        root.$axios
          .get("tutors/" + newSession.tutor + "/get_username")
          .then((req) => {
            if (req.data) {
              tutorInfo.value = req.data;
              if (tutorInfo.value.username == username) {
                editAllowed.value = true;
              }
            }
          });

        root.$axios
          .get("tutorials/" + root.$route.params.tutorialId)
          .then((req) => {
            const data = req.data;
            if (data) {
              tutorialInfo.value = data;
              if (!newSession.link) {
                newSession.link = data["link"];
              }
              if (!newSession.password) {
                newSession.password = data["link_password"];
              }
            }
            tutorSession.value = newSession;
          });
      });

    const getExactDate = (group: string, day: string, start?: string): Date => {
      const date = new Date(group);
      const weekList = ["Mo", "Di", "Mi", "Do", "Fr"];
      date.setDate(date.getDate() + weekList.indexOf(day));

      if (start) {
        const dateWithHour = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          parseInt(start),
          0,
          0
        );
        return dateWithHour;
      }

      return date;
    };

    const getExactDateInGermany = (date: Date): string => {
      let dateString = "";
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      } as const;
      dateString = date.toLocaleDateString("de-DE", options);
      return dateString;
    };

    const goToEventView = (eventType: string) => {
      root.$router.push({
        name: "tutorials.event",
        params: {
          eventType: eventType,
          id: tutorSession.value.id.toString(),
          tutor: tutorSession.value.tutor.toString(),
        },
      });
    };

    const passCurrent = (
      group: string,
      day: string,
      start: string
    ): boolean => {
      const currentDate = new Date();
      const sessionDay = getExactDate(group, day, start);
      return currentDate > sessionDay;
    };

    const updateLink = () => {
      if (tutorSession.value.link) {
        root.$axios
          .put("tutor_sessions/" + tutorSession.value.id + "/", {
            link: tutorSession.value.link,
            id: tutorSession.value.id,
          })
          .catch(() => {
            alert(root.$t("tutorSession.saveFailed"));
          });

        root.$axios.put("tutorials/" + root.$route.params.tutorialId + "/", {
          link: tutorSession.value.link,
          // eslint-disable-next-line @typescript-eslint/camelcase
          responsible_tutor: tutorInfo.value["username"],
        });
      }
    };

    const updateLinkPassword = () => {
      if (tutorSession.value.link && tutorSession.value.password) {
        root.$axios
          .put("tutor_sessions/" + tutorSession.value.id + "/", {
            // eslint-disable-next-line @typescript-eslint/camelcase
            link_password: tutorSession.value.password,
            id: tutorSession.value.id,
          })
          .then((req) => {
            if (req.status == 200) {
              // alert(root.$t("tutorSession.saveSucceed"));
            }
          })
          .catch(() => {
            alert(root.$t("tutorSession.saveFailed"));
          });

        root.$axios.put("tutorials/" + root.$route.params.tutorialId + "/", {
          // eslint-disable-next-line @typescript-eslint/camelcase
          link_password: tutorSession.value.password,
          // eslint-disable-next-line @typescript-eslint/camelcase
          responsible_tutor: tutorInfo.value["username"],
        });
      }
    };

    const formatFormat2 = (formatStr: string): string => {
      if (formatStr == "ONLINE") {
        return "online";
      } else if (formatStr == "PRESENCE") {
        return "präsenz";
      } else return "";
    };

    return {
      tutorSession,
      tutorInfo,
      tutorialInfo,
      loggedIn,
      isTutor,
      isStaff,
      editAllowed,

      goToEventView,
      passCurrent,
      getExactDateInGermany,
      getExactDate,
      updateLink,
      updateLinkPassword,
      formatFormat2,
    };
  },
});
